$(document).ready(function () {
    $('.section-quick-links a[href^="#"]').click(function (event) {
        event.preventDefault();
        let hash = this.hash;

        let headerHeight = $('.header').outerHeight() || 0;
        let dynamicOffset = 100;

        if ($(window).scrollTop() + $(window).height() > $(hash).offset().top) {
            dynamicOffset += 50;
        }

        $('html, body').animate({
            scrollTop: $(hash).offset().top - headerHeight - dynamicOffset
        }, 100);
    });

    $('.quick-links__links--slider').slick({
        dots: false,
        infinite: false,
        autoplay: false,
        speed: 300,
        centerPadding: '10px',
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1374,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: false,
                    dots: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false
                }
            }
        ]
    });
});

